"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasSurveyReachedMaxLaunches = exports.hasSurveyReachedMaxLaunchesPerSession = exports.isCriticalSurvey = exports.isBusinessCriticalSurvey = exports.isMultiLaunchSurvey = void 0;
var Api_1 = require("./Api/Api");
var Utils_1 = require("./Utils");
function isMultiLaunchSurvey(surveyInfo) {
  var maxLaunches = surveyInfo === null || surveyInfo === void 0 ? void 0 : surveyInfo.getMaxLaunches();
  return Utils_1.isNumber(maxLaunches) && maxLaunches > 1;
}
exports.isMultiLaunchSurvey = isMultiLaunchSurvey;
function isBusinessCriticalSurvey(surveyInfo) {
  var businessLevel = surveyInfo === null || surveyInfo === void 0 ? void 0 : surveyInfo.getBusinessLevel();
  return !Utils_1.isNOU(businessLevel) && businessLevel === Api_1.ISurveyInfo.BusinessLevel.Critical;
}
exports.isBusinessCriticalSurvey = isBusinessCriticalSurvey;
function isCriticalSurvey(surveyInfo) {
  return isMultiLaunchSurvey(surveyInfo) || isBusinessCriticalSurvey(surveyInfo);
}
exports.isCriticalSurvey = isCriticalSurvey;
function hasSurveyReachedMaxLaunchesPerSession(surveyInfo, surveyActivationStats) {
  var _a;
  if (isMultiLaunchSurvey(surveyInfo) && Utils_1.isNumber(surveyInfo.getMaxLaunchesPerSession())) {
    var surveyLaunchCountInSession = (_a = surveyActivationStats === null || surveyActivationStats === void 0 ? void 0 : surveyActivationStats.SurveyLaunchCountPerSession) !== null && _a !== void 0 ? _a : 0;
    var maxLaunchesPerSession = surveyInfo.getMaxLaunchesPerSession();
    return surveyLaunchCountInSession >= maxLaunchesPerSession;
  }
  return true;
}
exports.hasSurveyReachedMaxLaunchesPerSession = hasSurveyReachedMaxLaunchesPerSession;
function hasSurveyReachedMaxLaunches(surveyInfo, surveyActivationStats) {
  if (isMultiLaunchSurvey(surveyInfo)) {
    var surveyLaunchCount = (surveyActivationStats === null || surveyActivationStats === void 0 ? void 0 : surveyActivationStats.SurveyLaunchCount) || 0;
    return surveyLaunchCount >= surveyInfo.getMaxLaunches();
  }
  return true;
}
exports.hasSurveyReachedMaxLaunches = hasSurveyReachedMaxLaunches;